import styled from "styled-components";
import React from "react";
import {logAction} from "../../../../logging/logEvent";
import {IdeaRow} from "./IdeaRow";
import QuickEdit from "./quickEdit/QuickEdit";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
`;

export const IdeasTableBody = ({
                                   sortedIdeas,
                                   ideaActions,
                                   authorActions,
                                   tableRef,
                                   editingIdeaId,
                                   selectedIdeaAction,
                                   commentLengthLimit
                               }) => {
    function onMoreDetailsClick({ideaId, portfolioDetails}) {
        logAction({
            type: "OPEN_IDEA_ROW_CLICKED",
            ideaId: ideaId,
            portfolios: portfolioDetails
        });
        authorActions.hideQuickEdit();
        ideaActions.showDetail(ideaId);
    }

    function onRowClick({ideaId}) {
        authorActions.toggleQuickEdit(ideaId);
        logAction({
            type: editingIdeaId === ideaId ? "QUICK_EDIT_CLOSE" : "QUICK_EDIT_OPEN",
            ideaId: ideaId
        });
    }

    function onActionSelected(action) {
        authorActions.setIdeaAction(action);
    }

    return <Container className="t-open-idea-rows" ref={tableRef}>
        {sortedIdeas.map(idea => (
            <React.Fragment key={idea.ideaId}>
                <IdeaRow idea={idea}
                         shadow={idea.ideaId === editingIdeaId}
                         onRowClick={onRowClick}
                         onMoreDetailsClick={onMoreDetailsClick}/>
                {idea.ideaId !== editingIdeaId ? null :
                    <QuickEdit ideaId={idea.ideaId}
                               selectedAction={selectedIdeaAction}
                               onActionSelected={onActionSelected}
                               ideaActions={ideaActions}
                               commentLengthLimit={commentLengthLimit}/>}
            </React.Fragment>
        ))}
    </Container>;
};
